import { createAction } from '@reduxjs/toolkit';

/**
 * "Signal" action: the intent the UI dispatches for the saga to act on. Kept
 * out of the slice's reducers: it triggers a side effect (the PATCH), not a
 * state transition (the saga owns the resulting `save*` transitions).
 *
 * No payload: the write targets the self endpoint `PATCH /account`, where the
 * backend derives the user from the session, so the id never travels here.
 */
export const submitRequested = createAction('accountSettings/submitRequested');

/**
 * Profile photo signals (#579). The upload carries the picked `File` for the
 * saga; it never enters the state (see the serializable-check exception in
 * `store.ts`).
 */
export const avatarUploadRequested = createAction<File>('accountSettings/avatarUploadRequested');
export const avatarRemoveRequested = createAction('accountSettings/avatarRemoveRequested');
